import { ReactElement } from 'react'
import { Field, useField } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import _ from 'lodash'

// constants
import { FORM_BUILDER_MEDIA_CONFIGS } from 'constants/formBuilder'

// utils
import { getFieldName } from 'helpers/formBuilder'

// components
import * as FormComponents from 'components/common/Form'

const MaxMediaInput = ({
  nodeId,
  ...rest
}: {
  nodeId: string
}): ReactElement => {
  const isMultiInput = useField(getFieldName(nodeId, 'isMulti')).input
  const isMultiValue = isMultiInput.value

  const maxMediaFieldName = getFieldName(nodeId, 'maxItems')
  const maxMediaFieldInput = useField(maxMediaFieldName).input

  return (
    <>
      <OnChange name={getFieldName(nodeId, 'isMulti')}>
        {() => {
          if (isMultiValue) {
            if (_.isEmpty(maxMediaFieldInput.value)) {
              maxMediaFieldInput.onChange(FORM_BUILDER_MEDIA_CONFIGS.default)
            }
          } else {
            maxMediaFieldInput.onChange(FORM_BUILDER_MEDIA_CONFIGS.min)
          }
        }}
      </OnChange>
      <Field
        {...rest}
        {...(!isMultiValue && { label: undefined })}
        component={FormComponents.Input}
        type={isMultiValue ? 'number' : 'hidden'}
        min={FORM_BUILDER_MEDIA_CONFIGS.min}
        max={FORM_BUILDER_MEDIA_CONFIGS.max}
        step={FORM_BUILDER_MEDIA_CONFIGS.step}
        defaultValue={FORM_BUILDER_MEDIA_CONFIGS.default}
      />
    </>
  )
}

export default MaxMediaInput
